module.exports = __webpack_public_path__ + "img/hr-red-desert-bush-01.3231732b.png";